<template>
  <div :class="showPageRecord ? 'pagination-wrap' : ''">
    <div class="css-controls">
      <div class="page-size-select">
        <label for="ihaPageSize">Rows per page:</label>
        <select id="ihaPageSize" v-model="selectedPageSize" @change="handlePageSizeChange">
          <option v-for="size in pageSizes" :key="size" :value="size">{{ size }}</option>
        </select>
      </div>
      <div class="page-record" v-if="from && to && total && showPageRecord">
        <span>Showing {{ from }} to {{ to }} of {{ total }} results</span>
      </div>
    </div>
    <div class="table-pagination" v-if="total > perPage">
      <b-pagination
        v-if="total > 0"
        v-model="currentPage"
        :total-rows="total"
        :per-page="perPage"
        align="right"
        prev-text="Prev"
        next-text="Next"
        first-text="First"
        last-text="Last"
        @change="handlePageChange"
      ></b-pagination>
    </div>
  </div>
</template>

<script>
export default {
  name: "IhaPagination",
  props: {
    rows: {
      type: Object,
      default: () => ({}),
    },
    showPageRecord: {
      type: Boolean,
      default: true,
    },
    pageSizes: {
      type: Array,
      default: () => [10, 25, 50, 75, 100],
    },
  },
  data() {
    return {
      currentPage: this.rows.current_page || 1,
      selectedPageSize: this.rows.per_page || 10,
    };
  },
  computed: {
    from() {
      return this.rows.from || "";
    },
    to() {
      return this.rows.to || "";
    },
    total() {
      return this.rows.total || 0;
    },
    perPage() {
      return this.rows.per_page || this.selectedPageSize || 10;
    },
  },
  watch: {
    rows: {
      handler(value) {
        this.currentPage = value.current_page || 1;
        this.selectedPageSize = value.per_page || this.selectedPageSize;
      },
      deep: true,
    },
  },
  methods: {
    handlePageChange(page) {
      this.$emit("page-change", {
        page,
        pageSize: this.selectedPageSize,
      });
    },
    handlePageSizeChange() {
      this.$emit("page-change", {
        page: 1,
        pageSize: this.selectedPageSize,
      });
    },
  },
};
</script>

<style>
.pagination-wrap {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 1rem;
  flex-wrap: wrap;
  gap: 6px;
}

.page-link {
  border: none !important;
  color: #778699 !important;
}

.page-item.active .page-link {
  background-color: unset !important;
  color: #29bcff !important;
  border-bottom: 3px solid #29bcff !important;
}

.page-item .page-link:focus {
  box-shadow: unset !important;
}

.pagination ul li {
  font-size: 13px;
}

.page-item:first-child .page-link {
  padding-left: 0 !important;
}

@media (max-width: 768px) {
  .pagination-wrap {
    flex-wrap: wrap;
    row-gap: 0.75rem;
  }
}

@media (max-width: 499px) {
  .pagination {
    display: inline;
  }
  .page-record {
    margin-bottom: 1rem;
  }
}

.page-size-select {
  display: flex;
  align-items: center;
  gap: 8px;
}

.page-size-select label {
  font-size: 14px;
  font-weight: bold;
}

.page-size-select select {
  padding: 4px 8px;
  font-size: 14px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.page-record {
  font-size: 14px;
}

.css-controls {
  display: flex;
  align-items: center;
  gap: 16px;
}
</style>
